import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Observable, ReplaySubject } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { Room } from '@era/locations-sdk';

import { CategoryStoreSelectors } from '@era/stores';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-room-number',
  templateUrl: './room-number.container.html',
  styleUrls: ['./room-number.container.scss'],
  imports: [AsyncPipe],
})
export class RoomNumberComponent implements OnChanges {
  @Input() uniqueId: string;
  private uniqueId$ = new ReplaySubject<string>(1);

  public readonly roomNumber$: Observable<string>;
  constructor(private readonly store: Store<Room>) {
    this.roomNumber$ = this.uniqueId$.pipe(
      switchMap((uniqueId) => this.store.select(CategoryStoreSelectors.selectCategoryByUniqueId('Room', uniqueId))),
      filter((room) => !!room),
      map((room) => room.entity.displayName)
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.uniqueId) {
      this.uniqueId$.next(this.uniqueId);
    }
  }
}
